import App from "../App";
import { useRoutes } from "react-router-dom";
import Login from "../pages/Login";
import Home from "../pages/Home";
import Contact from "../pages/Contact";
import Notification from "../pages/Notification";
import Schedule from "../pages/Schedule";
import Exam from "../pages/Exam";
import ForgotPassword from "../pages/ForgotPassword";
const AppRouter = {
    path: "/",
    element: <App />,
    children: [
        { path: '', element: <Home /> },
        { path: '/contact', element: <Contact /> },
        { path: '/notification', element: <Notification /> },
        { path: '/schedule', element: <Schedule /> },
        { path: '/exam', element: <Exam /> },
    ],
};

const LoginRouter = {
    path: '/login',
    element: <Login />
}

const NotFound = {
}

const PasswordRouter = {
    path: 'forgot-password',
    element: <ForgotPassword />
}
export default function Router() {
    return useRoutes([AppRouter, LoginRouter, NotFound, PasswordRouter]);
}